import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Avatar from '../assets/images/users/avt1.png'
import Button from 'react-bootstrap/Button';
import { BiCalendarPlus } from "react-icons/bi";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { BiSearchAlt, BiCalendar, BiBarChartAlt2, BiLogIn } from "react-icons/bi";
import axios from 'axios';
import { Buffer } from 'buffer';
import { useNavigate } from 'react-router-dom';
import { callMsGraph } from '../callMsGroup';
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import {
    InteractionType,
    InteractionStatus,
    IPublicClientApplication,
    AccountInfo,
} from "@azure/msal-browser";
import LoadingScreen from './LoadingScreen';
import ScreenLoadingLogin from './ScreenLoadingLogin';
export default function Topbar(props: any) {
    const [isAdmin, setIsAdmin] = useState(false);
    const [keyword, setKeyword] = useState("");
    const { inProgress, instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [photoData, setPhotoData] = useState("");
    const [token, setToken] = useState("");
    const [apiToken, setApiToken] = useState("");
    const [profile, setProfile] = useState({ jobTitle: "" });
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const hendelChange = (e: any) => {
        const { value, name } = e.target
        setKeyword(value)
    }
    const hendleEnter = (e: any) => {
        if (e.keyCode === 13) {
            onSearch()
        }
    }
    const onSearch = () => {

        props.triggerSearch(keyword);
    }
    // const acquireAccessToken = async () => {
    //     const activeAccount = instance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    //     const accounts = instance.getAllAccounts();

    //     if (!activeAccount && accounts.length === 0) {
    //         instance.loginRedirect();
    //     }
    //     const request = {
    //         scopes: [`${process.env.REACT_APP_API_SCOPE1}`],
    //         account: activeAccount || accounts[0]
    //     };
    //     const requestProfile = {
    //         scopes: ["User.Read"],
    //         account: activeAccount || accounts[0]
    //     };

    //     const authResult = await instance.acquireTokenSilent(request);
    //     const authResultProfile = await instance.acquireTokenSilent(requestProfile);
    //     setApiToken(authResult.accessToken)
    //     setToken(authResultProfile.accessToken)
    //     localStorage.setItem("accessToken", authResult.accessToken);
    //     localStorage.setItem("accessProfileToken", authResultProfile.accessToken);
    //     return authResult.accessToken
    // };
    // const fetchUserGroups = async (accessToken: any) => {
    //     try {

    //         const groupsData = await callMsGraph(accessToken, "/me/transitiveMemberOf/microsoft.graph.group?$top=999");
    //         const groupExists = groupsData.value.some((group: any) => group.id === process.env.REACT_APP_SEC_ADMIN);

    //         setIsAdmin(groupExists)
    //         if (!groupExists) {
    //             window.location.href = window.location.origin + "/accessdenied"
    //         } else {
    //             setSuccess(true)
    //         }

    //        // console.log("Group ==>", groupsData.value);
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };
    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/", // The URI to redirect to after logout
        });
    };
    // useEffect(() => {
    //     acquireAccessToken();
    // }, [])
    // useEffect(() => {
    //     if (token !== "") {
    //         fetchUserGroups(token);
    //         const getPhoto = async () => {
    //             const graphEndpoint = "https://graph.microsoft.com/v1.0/me/photo/$value";

    //             const response = await axios(graphEndpoint, {
    //                 headers: { Authorization: `Bearer ${token}` },
    //                 responseType: "arraybuffer"
    //             });
    //             const avatar = Buffer.from(response.data, "binary").toString("base64");

    //             setPhotoData("data:image/jpeg;base64, " + avatar);
    //         };
    //         const getProfile = async () => {
    //             const graphEndpoint = "https://graph.microsoft.com/v1.0/me";

    //             const response = await axios(graphEndpoint, {
    //                 headers: { Authorization: `Bearer ${token}` }
    //             });
    //             setProfile(response.data);
    //         };
    //         getPhoto();
    //         getProfile();
    //     }
    // }, [token]);

    // if (!isAuthenticated && inProgress !== InteractionStatus.None) {
    //     return <LoadingScreen />;
    // }
    // if (!success) {
    //     return <ScreenLoadingLogin />;
    // }
    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <Navbar bg="white" data-bs-theme="light" className='px-2 ' sticky="top">
                    <div className='container-fluid'>
                    {props.isAdmin ? 
                        <Navbar.Brand onClick={() => navigate('/')} style={{cursor:"pointer"}}>C&S Events</Navbar.Brand>
                        :
                        <Navbar.Brand onClick={() => navigate('/myevents')} style={{cursor:"pointer"}}>C&S Events</Navbar.Brand>
                        }
                        <Nav className="me-auto top-menu ms-4">
                            <Nav.Link onClick={() => navigate('/')} className='active'><BiCalendar size={20} /> Events</Nav.Link>
                            {/* <Nav.Link href="#report"><BiBarChartAlt2 size={20} /> Report</Nav.Link> */}
                        </Nav>
                        <Nav>
                            <div className='border-end pe-3 search-bar'>
                                <div className="input-group">
                                    <input type="text" className="form-control" aria-describedby="basic-addon2" onChange={(e: any) => hendelChange(e)} onKeyDown={(e: any) => hendleEnter(e)} value={keyword} />
                                    <span className="input-group-text" id="basic-addon2" onClick={() => onSearch()}><BiSearchAlt /></span>
                                </div>
                            </div>
                            <img src={(props.photoData === "") ? Avatar : props.photoData} className='admin-img border ms-3' />
                            <div className='user-profile me-1 px-3'>
                                <label>{accounts[0]?.name}</label>
                                <p>
                                    <a className='text-gray' href={`${window.location.origin}/myevents`}>My Events</a>
                                </p>
                            </div>
                            <div className='add-event ps-3 border-start border-end me-1 px-3'>
                                <a className="btn   create-event-btn" href={'/events'}>
                                    <BiCalendarPlus /> <span>Create Event</span>
                                </a>
                            </div>
                            <div>
                                <BiLogIn className='logOut' onClick={() => handleLogout()} />
                            </div>
                        </Nav>
                    </div>
                </Navbar>
            </MsalAuthenticationTemplate>
        </>
    )
}
